import { z } from "zod";
import { OFFER_TARGETS, OFFER_CLAIM_STATUSES, DISCOUNT_TYPES } from "../types/sponsor-offer.js";

export const createOfferSchema = z.object({
  title: z.string().min(1).max(200),
  description: z.string().min(1).max(10000),
  discount_type: z.enum(DISCOUNT_TYPES).default("freeform"),
  discount_value: z.string().max(100).optional().nullable(),
  offer_code: z.string().max(100).optional().nullable(),
  target: z.enum(OFFER_TARGETS).default("school"),
  active: z.boolean().default(true),
  starts_at: z.string().datetime().optional().nullable(),
  ends_at: z.string().datetime().optional().nullable(),
  image_url: z.string().url().optional().nullable(),
  call_to_action_label: z.string().max(100).default("Claim Offer"),
  external_url: z.string().url().optional().nullable(),
});

export const updateOfferSchema = createOfferSchema.partial();

export const claimOfferSchema = z.object({
  school_id: z.string().min(1).optional().nullable(),
  contact_name: z.string().min(1).max(200),
  contact_email: z.string().email(),
  contact_phone: z.string().max(40).optional().nullable(),
  notes: z.string().max(2000).optional().nullable(),
  preferred_contact_time: z.string().max(200).optional().nullable(),
});

export const updateClaimSchema = z.object({
  status: z.enum(OFFER_CLAIM_STATUSES),
});

export type CreateOfferInput = z.infer<typeof createOfferSchema>;
export type UpdateOfferInput = z.infer<typeof updateOfferSchema>;
export type ClaimOfferInput = z.infer<typeof claimOfferSchema>;
export type UpdateClaimInput = z.infer<typeof updateClaimSchema>;
